export default "__VITE_ASSET__BwlM$kcp__"